import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { exchangeEmergentSession } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const match = window.location.hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/login", { replace: true }); return; }
    const session_id = decodeURIComponent(match[1]);
    // Clear the fragment immediately so it isn't re-used
    window.history.replaceState(null, "", window.location.pathname);
    exchangeEmergentSession(session_id)
      .then(() => { toast.success("Signed in with Google"); navigate("/dashboard", { replace: true }); })
      .catch(() => { toast.error("Google sign-in failed"); navigate("/login", { replace: true }); });
  }, [exchangeEmergentSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-slate-500 text-sm">Signing you in…</div>
    </div>
  );
}
